module.exports = __webpack_public_path__ + "static/assets/4a46aef47c55dcd1f6d89e7738a0b41b.png";